module.exports = __webpack_public_path__ + "img/신논현 미용실.c8063b2b.png";